
//FONTS
export const MAJOR_FONT = 'Merriweather';
export const MAJOR_FONT_WEIGHT = '500';
export const SUBSIDING_FONT = 'Open Sans';

//APPBAR
export const APPBAR_BG = 'white'

//MENU
export const MENU_FONT_SIZE = 'null';
export const MENU_FONT_COLOR = 'null';
export const MENU_WEIGHT = 'null'



//TESTIMONIAL 
export const TESTIMONIAL_GRADIENT_DIRECTION = 'bottom right';
export const TESTIMONIAL_START_COLOR = 'rgb(200,240,200)';
export const TESTIMONIAL_END_COLOR = 'rgb(200,200,200)';

export const TESTIMONIAL_BANNER_GRADIENT_DIRECTION =  'bottom';
export const TESTIMONIAL_BANNER_START_COLOR = 'rgb(168,193,188)';
export const TESTIMONIAL_BANNER_END_COLOR = 'rgb(200,240,200)';


//FOOTER CONSTANTS
export const FOOTER_TITLE_TEXT_COLOR = 'white';
export const FOOTER_TITLE_TEXT = 'DHAWALAGIRI BOARDING SCHOOL';
export const FOOTER_TITLE_TEXT_LINK = 'https://nepalschoolwebsite.netlify.app';

export const FOOTER_ONE_LINER = 'Bringing innovation in every step of student\'s life';
export const FOOTER_ONE_LINER_COLOR = 'black';

export const FOOTER_BG = 'rgb(168,193,188)';

export const FOOTER_FACEBOOK_LINK = 'https://facebook.com';
export const FOOTER_YOUTUBE_LINK = 'https://youtube.com';
export const FOOTER_TWITTER_LINK = 'https://twitter.com';

